// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#chatWindow-box {\n\twidth: 100%; \n\theight: 100%;\n}", "",{"version":3,"sources":["webpack://src/components/Chat/MessagesArea/styles.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,YAAY;AACb","sourcesContent":["#chatWindow-box {\n\twidth: 100%; \n\theight: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
